export default {
  placeholder: 'Select a data format',
};
